module.exports = __webpack_public_path__ + "img/right-hem.de4a6430.gif";